<template>
  <el-tooltip :content="`Copy ${ label }`" placement="top" effect="light">
    <el-button
        v-clipboard:copy="target"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        :disabled="buttonDisable"
        class="copy-btn" size="mini"
        type="text" plain round
    >
      {{ content }} <i class="mdi mdi-content-copy"></i>
    </el-button>
  </el-tooltip>
</template>

<script>
  export default {
    name: 'CopyButton',
    props: {
      label: {
        type: String,
        required: true
      },
      content: String,
      buttonDisable: {
        type: Boolean,
        default: false
      },
      target: {
        type: String,
        required: true
      }
    },
    methods: {
      onCopy() {
        this.$notify.success(`Copied to clipboard`)
      },
      onError() {
        this.$notify.error(`Failed to copy`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .copy-btn {
    color: #bdbfc3;
    font-size: 16px;
    border: none;

    &:hover {
      color: #5f8fdf;
    }
  }
</style>
